<template>
  <div class="max-w-screen-xl mx-auto">
    <div class="relative grid items-center gap-8 mt-6 mb-12 md:grid-cols-2 lg:mt-8 lg:mb-24">
      <div>
        <h1 class="mt-4 md:mt-6 lg:mt-8 text-3xl sm:text-4xl lg:text-6xl xl:text-7xl font-medium">
          {{ dataLocales.data.title }}
        </h1>
        <p class="mt-4 text-lg md:mt-6 lg:mt-8 md:text-xl text-grow">
          {{ dataLocales.data.description }}
        </p>
        <div class="flex mt-4 md:mt-6 w-fit lg:mt-8 xs:flex-row flex-col gap-4">
          <a :href="useRuntimeConfig().public.app_user_url" target="_blank" rel="noopener noreferrer"
            class="text-btn h-12 px-5 font-semibold bg-success hover:bg-successshades text-white whitespace-nowrap transition inline-flex items-center justify-center rounded-full">
            {{ $t('try_our_service') }}
          </a>
          <nuxt-link
            class="text-btn h-12 px-5 font-semibold box-border border text-neutrals-opaque-13 bg-white hover:bg-black/10 whitespace-nowrap transition inline-flex items-center justify-center rounded-full"
            to="/contact-us">{{ $t('contact') }}</nuxt-link>
        </div>
      </div>
      <div class="h-full hidden md:flex items-center justify-center ">
        <ClientOnly>
          <Vue3Lottie :animationData="marketingAnimation" :height="360" />
        </ClientOnly>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue3Lottie } from "vue3-lottie";
import "vue3-lottie/dist/style.css";
import marketingAnimation from "~/assets/animations/creative-3d-animation.json";
import DataLocale from "~~/config/interface/DataLocale";

export default defineComponent({
  components: {
    Vue3Lottie,
  },
  setup() {
    const dataLocales = new DataLocale([
      {
        locale: "en",
        title: " QR Codes in Marketing",
        description: " QR codes can help achieve the marketing goal of interacting with a customer or a potential customer rather than traditional advertisements and other media."
      },
      {
        locale: "vi",
        title: "Mã QR trong Marketing",
        description: "Mã QR có thể giúp đạt được mục tiêu tiếp cận và tương tác với khách hàng hoặc khách hàng tiềm năng hơn là sử dụng quảng cáo truyền thống và các phương tiện khác."
      },
      {
        locale: "de",
        title: "QR-Codes im Marketing",
        description: "QR-Codes können helfen, das Ziel des Marketings zu erreichen, mit einem Kunden oder potenziellen Kunden zu interagieren, anstatt auf traditionelle Werbung und andere Medien zu setzen."
      },
      {
        locale: "fr",
        title: "Les codes QR dans le marketing",
        description: "Les codes QR peuvent aider à atteindre l'objectif marketing d'interagir avec un client ou un client potentiel plutôt que d'utiliser des publicités traditionnelles et d'autres médias."
      },
      {
        locale: "nl",
        title: "QR-codes in marketing",
        description: "QR-codes kunnen helpen om het marketingdoel te bereiken om met een klant of potentiële klant te communiceren in plaats van traditionele advertenties en andere media."
      },
      {
        locale: "es",
        title: "Códigos QR en marketing",
        description: "Los códigos QR pueden ayudar a lograr el objetivo de marketing de interactuar con un cliente o posible cliente en lugar de anuncios tradicionales y otros medios."
      },
      {
        locale: "it",
        title: "Codici QR nel marketing",
        description: "I codici QR possono aiutare a raggiungere l'obiettivo di marketing di interagire con un cliente o un potenziale cliente invece di annunci pubblicitari tradizionali e altri media."
      },
      {
        locale: "pt",
        title: "Códigos QR em Marketing",
        description: "Os códigos QR podem ajudar a alcançar o objetivo de marketing de interagir com um cliente ou potencial cliente em vez de anúncios tradicionais e outras mídias."
      },
      {
        locale: "ja",
        title: "マーケティングにおけるQRコード",
        description: "QRコードは、従来の広告やその他のメディアではなく、顧客や潜在的な顧客とのやり取りのマーケティング目標を達成するのに役立ちます。"
      },
      {
        locale: "zh",
        title: "营销中的QR码",
        description: "QR码可以帮助实现与客户或潜在客户的互动而非传统广告和其他媒体的营销目标。"
      }
    ])
    return {
      marketingAnimation: ref(marketingAnimation), dataLocales
    };
  },
});
</script>
